import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import * as moment from 'moment';

Vue.mixin({
  data() {
    return {
      isMobileSize: false,
      isTabletSize: false,
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {

  },
  computed: {
    ...mapState('auth', ['credentials']),
    isAuthenticated() {
      let credentials = JSON.parse(this.credentials) || null;
      return credentials && credentials.accessToken;
    },
    $user() {
      let credentials = JSON.parse(this.credentials) || null;
      if (credentials === null) return null;
      return {
        id: credentials.userToken.id,
        email: credentials.userToken.email,
        nome: credentials.userToken.nome
      }
    },
    $app() {
      return {
        api: "http://localhost/apifinanceiro/",        
      }
    },
  },
  methods: {    
    ...mapMutations("alert", { openAlertSuccess: "showAlertSuccess", openAlert: "showAlert" }),
    ...mapMutations("dialog", { openDialog: "setAlertMessage", openConfirmDialog: "setConfirmMessage" }),
    onResize() {
      if (window.innerWidth >= 1170) {
        this.isMobileSize = this.isTabletSize = false;
      } else if (window.innerWidth < 1170 && window.innerWidth > 991) {
        this.isTabletSize = true;
        this.isMobileSize = !this.isTabletSize;
      } else {
        this.isMobileSize = true;
        this.isTabletSize = !this.isMobileSize;
      }
    },
    formatDate(date) {
      if (!date) return null;
      if (typeof (date) == "object") {
        return moment(date).format('DD/MM/YYYY');
      } else {
        const newDate = date.split('T');
        const [year, month, day] = newDate[0].split('-')
        return `${day}/${month}/${year}`
      }
    },
    formatCurrency(value, hasPrefix) {
      const { decimal, thousands, prefix } = { decimal: ',', thousands: '.', prefix: 'R$ ' };

      if (value === null)
        return (hasPrefix ? prefix : '') + '0' + decimal + '00';

      let newValue = value.toFixed(2).split('.');
      let numberPart = newValue[0];
      let newStr = '';
      let decimalPart = newValue[1];

      for (let index = numberPart.length - 1, indexDecimal = 1; index >= 0; index-- , indexDecimal++) {
        const element = numberPart[index];
        const by3 = indexDecimal % 3;
        newStr = element + newStr;
        if (by3 === 0 && index !== 0)
          newStr = thousands + newStr;
      }

      return (hasPrefix ? prefix : '') + newStr + decimal + decimalPart;
    },
    parseDate(date) {
      if (!date) return null
      let delimiter = date.split('-').length === 3 ? '-' : '/';
      if (delimiter == '-') {
        const [year, month, day] = date.split(delimiter);
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      } else {
        const [day, month, year] = date.split(delimiter);
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      }
    },
    parseDouble(valor) {
      let newValue = 0;                
      let str = '';
      if (valor)
          str = String(valor.replace(/[^\d]+/g, ''));               

      if (str) {
          str = String(parseInt(str));
          if (str.length < 3) {
              str = str.padStart(3, '0');
          }

          str = str.substring(0, str.length - 2) + '.' + str.substring(str.length - 2, str.length);

          newValue = parseFloat(str);
      }

      return newValue;
    }
  }
});